export default __webpack_public_path__ + "static/media/database-export.6a4a98dd.svg";